<script>
    import LoadingIcon from "./LoadingIcon.svelte";
    import {changeHandlerPassword, addAccount, setPrivateAnalyzeHandler, sendVerificationCode} from "../lib/ApiRequests.svelte";
    import {_} from '../lib/i18n';

    export let analyze;
    export let analyzeInProgress;
    export let show = false;

    let login = (analyze && analyze.handler) ? analyze.handler.login : '';
    let code;
    let errors = [];
    let isLoading = false;

    let handlerUsername;
    $: handlerUsername = (analyze && analyze.handler ? analyze.handler.login : '');

    let handlerAccountId;
    $: handlerAccountId = (analyze && analyze.handler ? analyze.handler.id : '');

    let targetUsername;
    $: targetUsername = (analyze && analyze.account ? analyze.account.username : '');

    async function sendCode() {
        isLoading = true;
        errors = [];

        if (analyze.handler.login === login) {
            try {
                const response = sendVerificationCode(analyze.handler.id, analyze.checkpoint.id, code);
                console.log(response);
                show = false;
            } catch (err) {
                console.error(err);
            }
        }

        isLoading = false;
    }

</script>

{#if show}
    <section class="private-acc-block system-info system-info_red" id="private-phone-verify">
        <div class="private-acc-block__title-wrapper system-info__title-wrapper">
            <div class="private-acc-block__title-icon system-info__title-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0001 9.16652V11.6665M9.77115 2.56527L4.77115 3.99384C4.4134 4.09605 4.16675 4.42304 4.16675 4.79511L4.16675 9.04471C4.16675 11.736 5.46646 14.2616 7.65643 15.8258L9.51572 17.1539C9.80546 17.3608 10.1947 17.3608 10.4844 17.1539L12.3437 15.8258C14.5337 14.2616 15.8334 11.736 15.8334 9.04471V4.79511C15.8334 4.42304 15.5868 4.09605 15.229 3.99384L10.229 2.56527C10.0794 2.52252 9.92078 2.52252 9.77115 2.56527Z" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <ellipse cx="10.0001" cy="6.66683" rx="0.833333" ry="0.833333" fill="#C93329"></ellipse>
                </svg>
            </div>
            <h3 class="private-acc-block__title-text system-info__title-text">
                {$_('checkpointAlert.title')}
            </h3>
        </div>
        <p class="private-acc-block__text system-info__text">
            {@html $_('checkpointAlert.description')}
        </p>

        <div class="private-acc-block__form form">
            <input type="text" class="private-acc-block__input general-input" placeholder="Введите код" bind:value={code} />
            <button class="button button_ghost form__btn form__btn_main private-acc-block__form-btn"
                    disabled={isLoading}
                    on:click={sendCode}
            >
                <LoadingIcon show={isLoading} width="16" height="16" />
                {$_('checkpointAlert.continueBtnLabel')}
            </button>
            <button class="button button_textual form__btn form__btn_secondary private-acc-block__form-btn">отправить код повторно</button>

            {#if errors.length > 0}
                {#each errors as error}
                    <p class="system-info__error private-acc-block__error">{error}</p>
                {/each}
            {/if}
        </div>
        <p class="private-acc-block__text system-info__text">{$_('checkpointAlert.warning')}</p>
        <div class="private-acc-block__controls-wrapper system-info__controls-wrapper">
            <div class="button button_textual system-info__controls-btn system-info__controls-btn_secondary private-acc-block__btn">
                {$_('checkpointAlert.cancel')}
            </div>
        </div>
    </section>
{/if}